import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Logo } from "@/components/site/Logo";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await login(f.email, f.password);
      nav("/admin");
    } catch (ex) {
      setErr(errMsg(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex relative bg-emerald-900 guilloche grain p-12 flex-col justify-between">
        <Logo light />
        <div className="space-y-4 max-w-md">
          <h2 className="font-display text-4xl font-extrabold text-white tracking-tight leading-tight">Espace d'administration du registre.</h2>
          <p className="text-emerald-100/80">Gestion des assistants en pharmacie, des cartes vertes et des communiqués officiels.</p>
        </div>
        <div className="text-xs text-emerald-200/60">Accès réservé au personnel autorisé.</div>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} data-testid="login-form" className="w-full max-w-sm space-y-6">
          <div className="lg:hidden"><Logo /></div>
          <div>
            <h1 className="font-display text-3xl font-bold tracking-tight text-slate-900">Connexion</h1>
            <p className="text-sm text-slate-500 mt-1">Administrateurs UAPHARCO uniquement.</p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required data-testid="login-email-input" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Mot de passe</Label>
            <Input id="password" type="password" required data-testid="login-password-input" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} />
          </div>
          {err && <p data-testid="login-error" className="text-sm text-rose-600">{err}</p>}
          <Button type="submit" disabled={busy} data-testid="login-submit-button" className="w-full rounded-full h-11">
            {busy && <Loader2 className="h-4 w-4 animate-spin mr-2" />} Se connecter
          </Button>
        </form>
      </div>
    </div>
  );
}
